import { Component, Input } from '@angular/core';

@Component({
    selector: 'ham-avatar',
    template: `
        <div class="ham-avatar" [ngClass]="avatarClass" [style]="avatarStyle">
            <ng-container *ngIf="imageUrl; else placeholder">
                <img [src]="imageUrl" [alt]="fullName" class="avatar-image" />
            </ng-container>
            <ng-template #placeholder>
                <span class="avatar-placeholder">{{ initials }}</span>
            </ng-template>
        </div>
        <div *ngIf="displayName" class="avatar-name">{{ fullName }}</div>
    `,
    styleUrls: ['./avatar.component.scss'],
})
export class HamAvatarComponent {
    @Input() type: 'circle' | 'rounded' = 'circle';
    @Input() size: 'regular' | 'xs' | 'l' | 'xl' | 's' = 'regular';
    @Input() variant: 'grey-border';
    @Input() imageUrl: string | null = null;
    @Input() fullName: string = '? ?';
    @Input() displayName: boolean = false;

    get avatarClass() {
        return `${this.size} ${this.type} ${this.variant}`;
    }

    get avatarStyle() {
        return this.imageUrl ? { 'background-image': `url(${this.imageUrl})` } : {};
    }

    get initials(): string {
        if (!this.fullName) return '';
        const words = this.fullName.trim().split(' ');
        if (words.length > 1) {
            // If there are at least two words, return the first letter of the first word and the first letter of the last word
            return (words[0][0] + words[words.length - 1][0]).toUpperCase();
        } else {
            // Otherwise, return the first two letters of the single word
            return this.fullName.slice(0, 2).toUpperCase();
        }
    }
}
